/* eslint-disable prefer-arrow-callback */
const { isFunction } = require('lodash')

let windowStore = {}
const windowConfig = {}
export function openWindow(url, type, callback) {
  const config = windowConfig[type]
  if (windowStore[config.name]) {
    windowStore[config.name].focus()
    return
  }
  const popup = window.open(url, config.name, config.style)
  windowStore[config.name] = popup
  const timer = window.setInterval(() => {
    if (!popup.closed) {
      return
    }
    window.clearInterval(timer)
    windowStore[config.name] = undefined
    if (isFunction(callback)) {
      callback()
    }
  }, 500)
}

export function closeAllWindows() {
  Object.values(windowStore).forEach(w => {
    if (w) {
      w.close()
    }
  })
  windowStore = {}
}

export function closeWindow(name) {
  const popup = windowStore[name]
  if (!popup) {
    return
  }
  popup.close()
  windowStore[name] = undefined
}
